module.exports = __webpack_public_path__ + "assets/968b4570b97ee0b22653ccadc3e1a7cd.mp3";